import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "app/features/reporting/templates/AssessmentReportFillTemplate";

export function AddMmseReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id ? `/residents/${resident.id}/mmse` : undefined;

  return (
    <AssessmentReportFillTemplate tag={FormEnums.MMSE} backPath={backPath} />
  );
}
